// extracted by mini-css-extract-plugin
module.exports = {"container":"ActionBubbleIcon_container__itkY5","container__icon":"ActionBubbleIcon_container__icon__3WaMr"};